module.exports = __webpack_public_path__ + "img/dede.26bf3e84.svg";